var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreGamesFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 50,
    viewBox: "0 0 98 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_1421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 26.25H47.75V13.75H37.75V26.25ZM37.75 36.25H47.75V28.75H37.75V36.25ZM50.25 36.25H60.25V23.75H50.25V36.25ZM50.25 13.75V21.25H60.25V13.75H50.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_1421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(34 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreGamesFilled);
export default __webpack_public_path__ + "static/media/more-games-filled.2e9969a885abc9a07419e410eb89f39c.svg";
export { ForwardRef as ReactComponent };